import type { SVGProps } from "react";

export default function ChatSendArrow(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.64014 5.49023L16.5091 5.49023L16.5091 13.3592"
        stroke="currentColor"
        strokeWidth="1.42629"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.49121 16.5098L16.4001 5.60088"
        stroke="currentColor"
        strokeWidth="1.42629"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
